
import { useState } from 'react';
import Hero from './components/Hero';
import WhyNow from './components/WhyNow';
import ForWhom from './components/ForWhom';
import WorkProcess from './components/WorkProcess';
import Income from './components/Income';
import Urgency from './components/Urgency';
import ApplicationForm from './components/ApplicationForm';
import Footer from '../../components/feature/Footer';
import CookieConsent from '../../components/feature/CookieConsent';

export default function Home() {
  const [showForm, setShowForm] = useState(false);

  const scrollToForm = () => {
    const formElement = document.getElementById('application-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <CookieConsent />
      <Hero onApplyClick={scrollToForm} />
      <WhyNow />
      <ForWhom />
      <WorkProcess />
      <Income />
      <Urgency onApplyClick={scrollToForm} />
      <ApplicationForm />
      <Footer />
    </div>
  );
}
